import { createSelector } from 'reselect';
import { capacityCheck } from '@utils/shop';

import getShop from './getShop';

const shopCapacityCheckActive = createSelector(getShop, shop =>
  capacityCheck(shop),
);

export default shopCapacityCheckActive;
